import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { AddTaskFormFields } from "@/modules/tasks/types";
import { TASK_FORM_DEFAULTS } from "@/modules/tasks/constants";

// Validation schema
export const addTaskSchema = () =>
  z.object({
    title: z
      .string()
      .min(1, "Title is required")
      .max(255, "Title must be less than 255 characters"),
    type: z.string().optional(),
    userUId: z.string().min(1, "Assignee is required"),
    dueDate: z
      .string()
      .min(1, "Due date is required")
      .refine(
        (dateTimeString) => {
          const dueDateTime = new Date(dateTimeString);
          const now = new Date();

          // Check if the complete datetime (date + time) is in the future
          return dueDateTime > now;
        },
        (dateTimeString) => {
          const dueDateTime = new Date(dateTimeString);
          const now = new Date();
          const dueDate = new Date(
            dueDateTime.getFullYear(),
            dueDateTime.getMonth(),
            dueDateTime.getDate()
          );
          const today = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
          );

          // If date is today, show time-specific error
          if (dueDate.getTime() === today.getTime()) {
            return { message: "Time must be in the future for today's date" };
          }

          // If date is in the past, show date error
          if (dueDateTime <= now) {
            return { message: "Due date must be in the future" };
          }

          return { message: "Due date and time must be valid" };
        }
      ),
    selectedTime: z.string().min(1, "Time is required"),
    linkedEntities: z.array(z.any()).optional().default([]),
  });

export function useAddTaskFormSetup() {
  const {
    handleSubmit: handleSubmitAddTask,
    reset: resetAddTask,
    formState: { errors: addTaskErrors },
    control: controlAddTask,
    setValue: setValueAddTask,
    getValues: getValuesAddTask,
  } = useForm<AddTaskFormFields>({
    resolver: zodResolver(addTaskSchema()),
    defaultValues: TASK_FORM_DEFAULTS,
  });

  return {
    handleSubmitAddTask,
    resetAddTask,
    addTaskErrors,
    controlAddTask,
    setValueAddTask,
    getValuesAddTask,
  };
}
